'use client';

import { useLandingLanguage } from '@/hooks/useLandingLanguage';
import { cadrinoWebsitePagesCopy, type CadrinoWebsitePagesCopy } from './website-pages-copy';
export function useWebsitePagesCopy() {
  const {
    language
  } = useLandingLanguage();
  return cadrinoWebsitePagesCopy[language === "en" ? "en" : "sr"];
}